import { render, staticRenderFns } from "./BuilderDesignLayout.vue?vue&type=template&id=5e763c8c"
import script from "./BuilderDesignLayout.vue?vue&type=script&lang=js"
export * from "./BuilderDesignLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports